/**
 * @ngdoc constant
 * @name MEDIA_STATUSES
 * @description
 * The status of a Media during the upload process; this status identify
 * media being uploaded on the APP; this values doesn't represent Media
 * on the Content Creator API.
 *
 * @memberof common
 * @type {Object}
 * @property {String}  init          This is the default status for Media Objects which
 *                                   was just created.
 * @property {String}  ok            This status represent media which is a safe image
 *                                   to sent to the Content Creator API.
 * @property {String}  preview       This status represent media which is being handle
 *                                   by the preview service.
 * @property {String}  previewOK     This status represent media has a valid preview.
 * @property {String}  previewFailed This status represent media which couldn't be
 *                                   previewed.
 * @property {String}  invalidImage  This status represent media which is not a valid
 *                                   image.
 * @property {String}  invalidSize   This status represent media selected which size
 *                                   is higher than the file size limit.
 */

const mediaStatuses = {
  init: 'INIT',
  ok: 'OK',
  previewOk: 'PREVIEW-OK',
  previewFail: 'PREVIEW-FAIL',
  invalidImage: 'INVALID-IMAGE',
  invalidSize: 'INVALID-SIZE',
};

export default mediaStatuses;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/constants/media.statuses.js